<template>
    <transition name="selection-bar">
        <div class="selection-action-bar">
            <div class="selection-bar-content">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "KvFloatingActionBar",
};
</script>

<style lang="scss" scoped>
.selection-action-bar {
    position: fixed;
    bottom: 24px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: max-content;
    z-index: 1050;
    background: #fff;
    border: 1.5px solid #2AAA4C;
    border-radius: 12px;
    padding: 10px 18px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.selection-bar-content {
    display: flex;
    align-items: center;
    gap: 10px;
    white-space: nowrap;
}

.selection-bar-enter-active {
    animation: slideUp 0.25s ease-out;
}
.selection-bar-leave-active {
    animation: slideUp 0.2s ease-in reverse;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
